var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo360"},[_c('div',{ref:"container",staticClass:"photo-compare-container",attrs:{"id":"photo-compare-container"}},[_c('div',{ref:"leftSide",staticStyle:{"width":"100%"}}),_c('div',{ref:"rightSide"})])])}
var staticRenderFns = []

export { render, staticRenderFns }